import React from "react";
import "./DiscountPackages.css";
import useWindowDimensions from "../../components/getWindowDimensions";

function DiscountPackages() {
  const { width } = useWindowDimensions();

  return (
    <div className="discount-packages-container">
      <div className="discount-packages-form-container">
        <iframe
          src="https://docs.google.com/forms/d/e/1FAIpQLSfB4hBkfiqIzlug0HQ8RDxuH7EzsIw2oGKEVLIbKMPh63mm1A/viewform?embedded=true"
          width={width < 1060 ? "100%" : "640"}
          height="796"
          frameBorder="0"
          marginHeight="0"
          marginWidth="0"
          title="Discount Packages Form"
        >
          Loading…
        </iframe>
      </div>
    </div>
  );
}

export default DiscountPackages;
